export default __webpack_public_path__ + "static/media/pic2.ab06847d.png";